module.exports = __webpack_public_path__ + "img/first-place.cadf1635.svg";